import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";

export default function NewsListCard({
  item,
  categoryLabel,
}: {
  item: ContentItem;
  categoryLabel: string;
}) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 rounded-xl bg-background-50 border border-background-200 p-4 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-full sm:w-56 h-44 sm:h-36 shrink-0 rounded-lg overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex flex-col">
        <div className="flex items-center gap-3 mb-2">
          <span className="px-2.5 py-0.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
            {categoryLabel}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-calendar-line" /> {item.date}
          </span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-2">
          {item.summary}
        </p>
        <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" /> {item.author}
          </span>
          <span className="flex items-center gap-1 text-accent-600">
            <i className="ri-fire-line" /> 热度 {item.heat}
          </span>
        </div>
      </div>
    </Link>
  );
}